import React, { useEffect, useState } from 'react';
import { useEventContext } from '../contexts/EventContext';
import { useUserContext } from '../contexts/UserContext';
import { Link } from 'react-router-dom';
import './style/Events.css';
import LoadingLogo from '../components/LoadingLogo';
import { Breadcrumbs } from '@aws-amplify/ui-react';
import { MdChevronRight } from 'react-icons/md';
import { useTranslation } from 'react-i18next';


function Events() {
  const { events, loadingEvents, errorEvents, refetchEvents } = useEventContext();
  const { tokens, userInfo } = useUserContext();
  const [currentPage, setCurrentPage] = useState(1);
  const { t } = useTranslation();

  useEffect(() => {
    if (tokens?.accessToken && userInfo?.username) {
      refetchEvents();
    }
  }, [tokens, userInfo]);

  const itemsPerPage = 9;
  const totalPages = Math.ceil(events.length / itemsPerPage);

  if (loadingEvents) {
    return <LoadingLogo />;
  }

  if (errorEvents) {
    return <div className="events-error">{t("eventserror.Recuperation")} : {errorEvents}</div>;
  }

  // ✅ Affichage lisible de la date/heure avec vérification
  const parseDateFrToLocale = (dateTimeStr) => {
    if (typeof dateTimeStr !== 'string') return 'Date manquante';

    const [datePart, timePart] = dateTimeStr.split(' ');
    if (!datePart || !timePart) return 'Date invalide';

    const [day, month, year] = datePart.split('/');
    const [hour, minute] = timePart.split(':');

    if (!day || !month || !year || !hour || !minute) return 'Date invalide';

    const dateObj = new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute)
    );

    return isNaN(dateObj.getTime())
      ? 'Date invalide'
      : dateObj.toLocaleString('fr-FR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        });
  };

  // ✅ Format ISO pour le tri
  const formatDateTimeToISO = (dateTimeStr) => {
    if (typeof dateTimeStr !== 'string') return '';

    const [datePart, timePart] = dateTimeStr.split(' ');
    if (!datePart || !timePart) return '';

    const [day, month, year] = datePart.split('/');
    const [hour, minute] = timePart.split(':');

    if (!day || !month || !year || !hour || !minute) return '';

    return new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute)
    ).toISOString();
  };

  const sortedEvents = [...events].sort((a, b) => {
    const dateA = new Date(formatDateTimeToISO(a.createdAt));
    const dateB = new Date(formatDateTimeToISO(b.createdAt));
    return dateB - dateA;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentEvents = sortedEvents.slice(indexOfFirstItem, indexOfLastItem);

  if (!loadingEvents && events.length === 0) {
    return (
      <div className="create-event-page">
        <div className="create-event-container">
          <h2>{t('listevent.createfirstevent')}</h2>
          <p style={{ textAlign: 'center', marginBottom: '20px' }}>
            {t('listevent.emptyfirstevent')}
          </p>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Link to="/create-event">
              <button>{t('listevent.createfirsteventButton')}</button>
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="events-container">
      <div style={{ marginTop: '10px' }}>
        <Breadcrumbs
          items={[
            { label: '' },
            { label: t("Event") }
          ]}
          separator={<MdChevronRight style={{ color: '#facc15' }} />}
        />
      </div>
      <h2>{t('listevent.listevent')}</h2>
      <div className="events-grid">
        {currentEvents.map((event) => (
          <Link to={`/events/${event.eventId}`} key={event.eventId} className="event-card">
            <div className="event-content">
              <div className="event-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#facc15"
                  viewBox="0 0 24 24"
                  width="28px"
                  height="28px"
                >
                  <path d="M19 4h-1V2h-2v2H8V2H6v2H5C3.9 4 3 4.9 3 6v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z" />
                </svg>
              </div>
              <div className="event-info">
                <h3 className="event-title">{event.eventName}</h3>
                <p className="event-date">
                  {t('listevent.createdat')} : {parseDateFrToLocale(event.createdAt)}
                </p>
                <p className="event-date">Type : {event.eventType}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>

      {/* Pagination */}
      <div className="pagination-controls">
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
        >
          ← {t('Precedent')}
        </button>
        <span>Page {currentPage} / {totalPages}</span>
        <button
          onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages}
        >
          {t('Suivant')} →
        </button>
      </div>

      <div className="footer-glow" />
    </div>
  );
}

export default Events;
